module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// /Users/sandersturing/Sites/SD/dudok.test/frontend/node_modules/normalize-wheel/index.js
// module id = 352
// module chunks = 0